export const partition = <T, Transformed = T>(
  array: T[],
  filter: (el: T, index: number, arr: T[]) => boolean,
  // Working around that annoying "could be instantiated with an arbitrary
  // type" warning.
  // @ts-expect-error
  modifier?: (el: T) => Transformed = (el) => el,
) => {
  let pass: Transformed[] = []
  let fail: Transformed[] = []
  array.forEach((el, index, arr) =>
    (filter(el, index, arr) ? pass : fail).push(modifier(el)),
  )
  return [pass, fail] as const
}

export default partition
